/**
 * This function adds the attribute specified in the attribute 'add-attr' to the href.
 */
const addAttrToHref = () => {
    const buttons = document.querySelectorAll('[add-attr]');
    buttons.forEach(button => {
        let element = button.querySelector('a');
        let attr = button.getAttribute('add-attr');
        element.href += `?${attr}=${element.getAttribute(attr)}`;
    });
};

export default addAttrToHref;